import BaseProxy from './Proxy';

export default class TransactionBundlesProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/bundleSearch', parameters);
  }
}
